export default function Rust_Variables() {
  return (
    <div>
      <h1>Rust_Variables Component</h1>
      <p>This is the Rust_Variables page.</p>
    </div>
  );
}
